import React from 'react';
import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import DebriefScoreToggle from 'ff/debrief/components/settings/DebriefScoreToggle';
import { styled } from '@mui/material/styles';
import DebriefPopoverTitle from 'ff/debrief/common/components/DebriefPopoverTitle';

interface Props {
    anchorEl: HTMLButtonElement | null;
    open: boolean;
    onClose: () => void;
}

const SettingsPopover = (props: React.PropsWithChildren<Props>) => {
    return (
        <Popover
            open={props.open}
            anchorEl={props.anchorEl}
            onClose={props.onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            slotProps={{
                paper: {
                    sx: {
                        backgroundColor: 'white',
                        borderRadius: '2px 2px 0px 0px',
                    },
                },
            }}
            sx={{
                '& .MuiPaper-root': { mt: 1 },
            }}
        >
            <Box>
                <DebriefPopoverTitle onClose={props.onClose}>
                    Settings
                </DebriefPopoverTitle>

                <ToggleContainer>
                    <DebriefScoreToggle />
                </ToggleContainer>
            </Box>
        </Popover>
    );
};

const ToggleContainer = styled(Box)`
    padding: 4px 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid #becad4;
    gap: 8px;
    cursor: pointer;
`;

export default SettingsPopover;
